import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import TextField from '@material-ui/core/TextField';
import { InterEstateLeafSchemaObject } from '../ValidationSchema';
import { validateProperty, validate } from "../../../Common";
import divisionService from '../../../Devision/services';
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _, { forEach } from 'lodash';
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import $ from 'jquery';
import xlsx from 'json-as-xlsx';
import TablePagination from '@material-ui/core/TablePagination';
import MessageModal from '../../../../UI/Modal/MessageModal';
const screenCode = 'INTERESTATELEAFREPORTBL';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function InterEstateLeafBLListing(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [errors, setErrors] = useState({});
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [isTableHide, setIsTableHide] = useState(true);
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [interEstateLeafReport, setinterEstateLeafReport] = useState([])

    const schema = Joi.object(InterEstateLeafSchemaObject).options({ allowUnknown: true });

    const contentRowNames = ["interEstate", "interEstateDivision", "gross", "deduction", "net"];
    const [csvHeaders, setCsvHeaders] = useState([
        { label: "Inter Estate", value: "interEstate" },
        { label: "Inter Estate Division", value: "interEstateDivision" },
        { label: "Gross (Kg)", value: "gross" },
        { label: "Deduction (Kg)", value: "deduction" },
        { label: "Net (Kg)", value: "net" }
    ]);

    const [totalCollections, setTotalCollections] = useState({
        gross: 0,
        deduction: 0,
        net: 0
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [searchForm, setSearchForm] = useState({
        groupID: '0',
        factoryID: '0',
        date: moment().format('YYYY-MM-DD')
    });
    const [resultData, setResultData] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({});
    const [csvData, setCsvData] = useState([]);
    const totalGross = interEstateLeafReport.reduce((total, row) => total + Math.ceil(row.gross), 0);
    const totalDeduction = interEstateLeafReport.reduce((total, row) => total + Math.floor(row.deduction), 0);
    const totalNet = interEstateLeafReport.reduce((total, row) => total + Math.floor(row.net), 0);
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchForm.groupID])

    useEffect(() => {
        destroyDataTable();
        createDataTable();
    }, [resultData])

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await services.getOperationEntitiesByGroupForDropDown(searchForm.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWINTERESTATELEAFREPORTBL');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setSearchForm({
                ...searchForm,
                groupID: token.groupID,
                FactoryID: token.operationEntityID
            });

        } else {
            setSearchForm({
                ...searchForm,
                groupID: token.groupID,
                FactoryID: token.operationEntityID
            });
        }

        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            FactoryID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function handleSearch(e) {
        e.preventDefault();

        setIsTableHide(true);
        setIsReportButtonsEnabled(false);

        const errorMessages = validate(schema, searchForm);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var copyOftotalCollections = totalCollections;
        var csvHeadersCopy = csvHeaders;

        for (const key in copyOftotalCollections) {
            copyOftotalCollections[key] = 0;
        }

        setTotalCollections(copyOftotalCollections);

        var result = await services.GetReportData(searchForm);
        if (result.length > 0) {

            var joinedResult = [];
            var finalResult = [];

            let lemp2 = _.groupBy(result, 'operationEntityID')
            const finalResult1 = Object.values(lemp2)

            finalResult1.forEach(x => {
                x.totalGross = 0;
                x.totalDeduction = 0;
                x.totalNet = 0;

                x.forEach(y => {
                    x.totalGross += Number(y.gross);
                    x.totalDeduction += Number(y.deduction);
                    x.totalNet += Number(y.net);
                });
            });
            const groupedData = groupByEstate(result);
            setinterEstateLeafReport(finalResult1);
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
            getSelectedDropdownValuesForReport(searchForm)
            setReportDataForDisplay(result);
        }
        else {
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }

        generateCsvData(result);
    }

    function createFile() {
        var settings = {
            sheetName: 'Inter Estate Leaf',
            fileName: 'InterEstateLeafReport',
            writeOptions: {}
        };
        var dataForExcel = resultData.map(item => ({
            ...item,
            gross: Math.ceil(parseFloat(item.gross)),
            deduction: parseFloat(item.deduction).toFixed(2),
            net: parseFloat(item.net).toFixed(2)
        }));

        var newRow1 = {
            interEstate: "Group :" + groups[searchForm.groupID],
            interEstateDivision: "Operation Entity : " + operationEntity[searchForm.factoryID],
            gross: "Date : " + searchForm.date
        }

        let groupedByEstate = _.groupBy(dataForExcel, 'interEstate');
        let finalData = [];

        Object.keys(groupedByEstate).forEach(estate => {
            let group = groupedByEstate[estate];
            finalData.push(...group);

            let totals = group.reduce((acc, row) => {
                acc.gross += parseFloat(row.gross);
                acc.deduction += parseFloat(row.deduction);
                acc.net += parseFloat(row.net);
                return acc;
            }, { gross: 0, deduction: 0, net: 0 });

            finalData.push({
                interEstate: "Total for " + estate,
                interEstateDivision: "",
                gross: Math.ceil(totals.gross),
                deduction: totals.deduction.toFixed(2),
                net: totals.net.toFixed(2),
                isTotal: true
            });
            finalData.push({});
        });

        let grandTotals = finalData.reduce((acc, row) => {
            if (row.isTotal) {
                acc.gross += parseFloat(row.gross);
                acc.deduction += parseFloat(row.deduction);
                acc.net += parseFloat(row.net);
            }
            return acc;
        }, { gross: 0, deduction: 0, net: 0 });

        finalData.push({
            interEstate: "Grand Total",
            interEstateDivision: "",
            gross: Math.ceil(grandTotals.gross),
            deduction: grandTotals.deduction.toFixed(2),
            net: grandTotals.net.toFixed(2)
        });

        finalData.push({}, {}, newRow1)
        xlsx(csvHeaders, finalData, settings, true);
    }

    function groupByEstate(data) {
        const grouped = data.reduce((acc, item) => {
            const id = item.OperationEntityID;
            acc[id] = acc[id] || {
                interEstate: item.interEstate,
                rows: [],
                totalGross: 0,
                totalDeduction: 0,
                totalNet: 0
            };
            acc[id].rows.push(item);
            acc[id].totalGross += parseFloat(item.gross);
            acc[id].totalDeduction += parseFloat(item.deduction);
            acc[id].totalNet += parseFloat(item.net);
            return acc;
        }, {});

        return Object.values(grouped);
    }

    function setReportDataForDisplay(data) {
        var resultArray = [];
        data.forEach(x => {
            resultArray.push({
                interEstate: x.interEstate,
                interEstateDivision: x.interEstateDivision,
                gross: (x.gross),
                deduction: (x.deduction),
                net: (x.net)
            })
        });
        setResultData(resultArray);
    }

    function generateCsvData(data) {
        const newData = [...data];

        let totalGross = 0;
        let totalDeduction = 0;
        let totalNet = 0;

        newData.forEach(x => {

            if (!isNaN(x.gross)) totalGross += Math.floor(x.gross);
            if (!isNaN(x.deduction)) totalDeduction += Math.floor(x.deduction);
            if (!isNaN(x.net)) totalNet += Math.floor(x.net);
        });

        const total = {
            interEstate: "Total",
            interEstateDivision: "",
            gross: Math.floor(totalGross),
            deduction: Math.floor(totalDeduction),
            net: Math.floor(totalNet)
        };

        const newArray = newData.map(x => ({
            interEstate: x.interEstate,
            interEstateDivision: x.interEstateDivision,
            gross: Math.floor(x.gross),
            deduction: Math.floor(x.deduction),
            net: Math.floor(x.net)
        }));

        newArray.push(total);
        setCsvData(newArray);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, InterEstateLeafSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.factoryID],
            date: searchForm.date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div>
                        <PageHeader
                            title="Inter Estate Leaf Report"
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="factoryID"
                                            value={searchForm.factoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.fromEntries(
                                                    Object.entries(operationEntity).filter(([key, value]) => {
                                                        if (key === "0" || !value) return false;
                                                        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                            return true;
                                                        }
                                                        return Object.values(multipleEstates).includes(value);
                                                    })
                                                )
                                            )}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="factoryID" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="date">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            value={searchForm.date}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>

                                <input
                                    type="submit"
                                    disabled={validate(schema, searchForm)}
                                    className="btn btn-primary"
                                    value="Generate"
                                />

                                {isTableHide ? null :
                                    <div>
                                        <div className="table-responsive row-top-gap" >
                                            <div>
                                                <TableContainer component={Paper}>
                                                    <Table className={classes.table} aria-label="simple table">
                                                        <TableHead style={{ border: "2px solid black" }} >
                                                            <TableRow>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Inter Estate</TableCell>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Inter Estate Division</TableCell>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Gross (Kg)</TableCell>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Deduction (Kg)</TableCell>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Net (Kg)</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {interEstateLeafReport.map((row) => {
                                                                return (
                                                                    <>
                                                                        {
                                                                            row.map((column) => (
                                                                                <TableRow style={{ border: "2px solid black" }}
                                                                                >
                                                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="left"> {column.interEstate}</TableCell>
                                                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="left"> {column.interEstateDivision}</TableCell>
                                                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center">{Math.ceil(parseFloat(column.gross))}</TableCell>
                                                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center"> {parseFloat(column.deduction).toFixed(2)}</TableCell>
                                                                                    <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center"> {parseFloat(column.net).toFixed(2)}</TableCell>
                                                                                </TableRow>
                                                                            ))
                                                                        }
                                                                        <TableRow style={{ border: "2px solid black" }}
                                                                        >
                                                                            <TableCell colSpan={2} style={{ border: "2px solid black" }} component="th" scope="row" align="left">Total</TableCell>
                                                                            <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center">{Math.ceil(parseFloat(row.totalGross))}</TableCell>
                                                                            <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center"> {parseFloat(row.totalDeduction).toFixed(2)}</TableCell>
                                                                            <TableCell style={{ border: "2px solid black" }} component="th" scope="row" align="center"> {parseFloat(row.totalNet).toFixed(2)}</TableCell>
                                                                        </TableRow>
                                                                    </>
                                                                );
                                                            })}
                                                            <TableRow style={{ border: "2px solid black" }}>
                                                                <TableCell colSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }} align="left">Grand Total</TableCell>
                                                                <TableCell style={{ border: "2px solid black", fontWeight: "bold" }} align="center">
                                                                    {Math.ceil(interEstateLeafReport.reduce((acc, cur) => acc + parseFloat(cur.totalGross), 0))}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", fontWeight: "bold" }} align="center">
                                                                    {interEstateLeafReport.reduce((acc, cur) => acc + parseFloat(cur.totalDeduction), 0).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", fontWeight: "bold" }} align="center">
                                                                    {interEstateLeafReport.reduce((acc, cur) => acc + parseFloat(cur.totalNet), 0).toFixed(2)}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                    <TablePagination
                                                        component="div"
                                                        count={interEstateLeafReport.length}
                                                        onChangePage={handlePageChange}
                                                        onChangeRowsPerPage={handleLimitChange}
                                                        page={page}
                                                        rowsPerPage={limit}
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                    />
                                                </TableContainer>
                                            </div>
                                        </div>
                                        {!isReportButtonsEnabled ? null :
                                            <div className="pt-2">
                                                <ReactToPrint
                                                    documentTitle={"Inter Estate Leaf Report"}
                                                    trigger={() => <input
                                                        type="button"
                                                        className="btn btn-primary pull-right ml-2"
                                                        value="Create PDF"
                                                    />}
                                                    content={() => componentRef.current}
                                                />
                                                <div hidden={true}>
                                                    <CreatePdf ref={componentRef} interEstateLeafReport={interEstateLeafReport} contentRowNames={contentRowNames} totalGross={totalGross}
                                                        totalDeduction={totalDeduction} totalNet={totalNet} selectedSearchValues={selectedSearchValues}
                                                    />
                                                </div>
                                                <input
                                                    type="button"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="Excel"
                                                    onClick={createFile}
                                                />
                                            </div>
                                        }
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    )
}

